// Use em in media query to work properly cross-browser and support users
// https://zellwk.com/blog/media-query-units/
export enum Media {
  SMALLEST = "(max-width: 21em)", // = 320px / 16px (iPhone5)
  SMALLER = "(min-width: 25em)", // = 400px
  SMALL = "(max-width: 60.4em)", // = 599px / 16px
  LARGE = "(min-width: 60.5em)", // = 968px / 16px
}
